/**
 * @module builder
 */
import type { OptionsDocument } from 'paintscout'
import type { ProductOption } from '../../index'

export function updateProductOptions(args: {
  productOptions: ProductOption[]
  options: OptionsDocument
}): OptionsDocument {
  const { options, productOptions } = args

  const order = [...options.options.products.order]
  const quoteTypeOrder = { ...options.options.products.quoteTypeOrder }
  const values = { ...options.options.products.values }

  for (const productOption of productOptions) {
    const { key, quoteTypes = [] } = productOption

    // Ensure key is in order array
    if (!order.includes(key)) {
      order.push(key)
    }

    // Ensure key is in each relevant quoteTypeOrder list
    quoteTypes.forEach((quoteType: string) => {
      if (quoteTypeOrder[quoteType]) {
        const quoteTypeOrderIndex = quoteTypeOrder[quoteType].indexOf(productOption.key)
        if (quoteTypeOrderIndex === -1) {
          quoteTypeOrder[quoteType].push(productOption.key)
        }
      }
    })

    const convertedProduct: ProductOption = {
      key: productOption.key,
      productLineId: productOption.productLineId ?? '',
      manufacturer: productOption.manufacturer ?? '',
      label: productOption.label,
      coverage_rate:
        typeof productOption.coverage_rate === 'string'
          ? parseFloat(productOption.coverage_rate)
          : productOption.coverage_rate,
      lnft_coverage:
        typeof productOption.lnft_coverage === 'string'
          ? parseFloat(productOption.lnft_coverage)
          : productOption.lnft_coverage,
      quantity_coverage:
        typeof productOption.quantity_coverage === 'string'
          ? parseFloat(productOption.quantity_coverage)
          : productOption.quantity_coverage,
      price: typeof productOption.price === 'string' ? parseFloat(productOption.price) : productOption.price,
      quoteTypes: productOption.quoteTypes ? productOption.quoteTypes : [],
      active: productOption.active,
      category: productOption.category ?? '',
      unitLabel: productOption.unitLabel,
      rateTypes: productOption.rateTypes ? productOption.rateTypes : [],
      description: productOption.description ?? '',
      featureImage: productOption.featureImage ?? null,
      featureProduct: productOption.featureProduct ?? false
    }

    values[key] = {
      active: true,
      ...values[key], // preserve any existing props
      ...convertedProduct // override or add from new
    }
  }

  return {
    ...options,
    options: {
      ...options.options,
      products: {
        ...options.options.products,
        values,
        order,
        quoteTypeOrder
      }
    }
  }
}
